<template>
  <transition name="fade" mode="out-in">
    <form v-if="qrCode" v-on:submit.prevent="activate">
      <div v-if="finish">
        <Icon
          type="check"
          backgroundColor="green"
          borderColor="green"
          :rounded="true"
          :size="1.5"
        />
        <Divider />
        <p>
          Successfully Activated
        </p>
        <DecoratedButton type="button" @click="close">
          CLOSE
        </DecoratedButton>
      </div>
      <div v-else>
        <transition name="fade" mode="out-in">
          <code class="secret" v-if="showSecret">{{ secret }}</code>
          <img v-else class="img" :src="qrCode" />
        </transition>
        <Divider />
        <DecoratedButton
          type="button"
          @click="showSecret = !showSecret"
          class="plain"
          :short="true"
          color="#000"
        >
          {{ showSecret ? "Scan barcode" : "Not able to scan the barcode?" }}
        </DecoratedButton>
        <Divider />
        <a
          href="https://itunes.apple.com/us/app/google-authenticator/id388497605"
          target="_blank"
        >
          <img
            src="/static/images/logos/apple-store-badge.svg"
            alt="Download from the App Store"
          />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
          target="_blank"
        >
          <img
            src="/static/images/logos/google-play-badge.svg"
            alt="Download from Google Play"
          />
        </a>
        <Divider />
        <p>
          Scan the barcode above with your Authenticator app,<br />
          then enter your verification code.
        </p>
        <Divider />
        <FieldWrapper>
          <div slot="input">
            <CodeInput :numberOfFields="6" @input="setCode" />
          </div>
          <input
            type="hidden"
            v-model="code"
            name="code"
            placeholder="CODE"
            v-validate="validatorDefinitions.authCode"
            data-vv-scope="code"
            maxlength="6"
          />
        </FieldWrapper>
      </div>
    </form>
    <div v-else>
      <DecoratedButton :loading="loading" @click="init" type="button">
        ACTIVATE
      </DecoratedButton>
    </div>
  </transition>
</template>

<script>
import CodeInput from "@/components/partials/auth/Code";

export default {
  name: "profile-modal-two-factor-init",
  components: { CodeInput },
  data: function() {
    return {
      qrCode: null,
      secret: null,
      showSecret: false,
      loading: false,
      finish: false,
      code: null
    };
  },
  methods: {
    init() {
      this.loading = true;
      this.services.UserResource.authCodeInit()
        .then(response => {
          this.loading = false;
          this.qrCode = response.data.img;
          this.secret = response.data.secret;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    setCode(code) {
      if (this.code !== code) {
        this.code = code;
        this.activate();
      }
    },
    activate() {
      this.$validator.validateAll("code").then(valid => {
        if (valid) {
          this.loading = true;

          this.services.UserResource.authCodeActivate({
            code: this.code
          })
            .then(response => {
              this.finish = true;
              this.loading = false;
            })
            .catch(err => {
              this.loading = false;
            });
        }
      });
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input {
  text-align: center;
}

.img {
  border: 4px solid #000000;
}

.secret {
  border: 1px solid #000;
  text-align: center;
  padding: 15px;
  font-size: 0.8em;
  word-wrap: break-word;
  display: block;
  margin: 0;
}
</style>
